//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    deeplink: {}
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  methods: {
    updateDeeplinkFrom: function updateDeeplinkFrom(value) {
      this.$emit('update-deeplink-from', value);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/assistant/AssistantStore.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/assistant/AssistantStore.vue
// module chunks = 10